import { MultiColumnFormFields } from "@components/common/form/FormFields";
import { PeekButton, PeekDialogActions, PeekDialogContent, PeekDivider, PeekStack, PeekTypography, theme, } from "@piiqtechnologies/ui-components";
import { useCommunities } from "@piiqtechnologies/ui-lib";
import { Form, Formik } from "formik";
import React, { useEffect, useMemo } from "react";
import { useIntl } from "react-intl";
import { DownloadAnalyticsFormFields, DownloadAnalyticsFormInitialValues, DownloadAnalyticsFormValidationSchema, } from "./DownloadAnalyticsFormConfig";
import messages from "./messages.i18n";
const DownloadAnalyticsForm = ({ period, communityIds, onDownload }) => {
    const intl = useIntl();
    const [getCommunities, communitiesResponse, communitiesInProgress, communitiesError] = useCommunities();
    useEffect(() => {
        getCommunities();
    }, []);
    const formattedCommunities = useMemo(() => {
        var _a;
        return (_a = communitiesResponse === null || communitiesResponse === void 0 ? void 0 : communitiesResponse.data) === null || _a === void 0 ? void 0 : _a.map((community) => ({
            name: community.name,
            _id: community._id,
        }));
    }, [communitiesResponse]);
    const { dateRange, communities, others } = DownloadAnalyticsFormFields(formattedCommunities);
    return (React.createElement(Formik, { onSubmit: onDownload, initialValues: DownloadAnalyticsFormInitialValues(period, communityIds), validationSchema: DownloadAnalyticsFormValidationSchema() }, ({ values }) => {
        return (React.createElement(Form, { style: { marginTop: "0 !important" } },
            React.createElement(PeekDialogContent, { sx: {
                    py: theme.spacing(1),
                    px: theme.spacing(2),
                    ".MuiCheckbox-root": {
                        padding: 0.6,
                    },
                } },
                React.createElement(PeekStack, { spacing: 2 },
                    React.createElement(MultiColumnFormFields, { fullWidth: true, fields: dateRange }),
                    React.createElement(MultiColumnFormFields, { fullWidth: true, fields: communities }),
                    React.createElement(PeekStack, { spacing: 1 },
                        React.createElement(PeekTypography, { variant: "h4", fontWeight: "fontWeightMedium" }, "Reports"),
                        React.createElement(PeekDivider, { orientation: "horizontal", sx: { borderColor: theme.palette.grey[200], width: "100%" } })),
                    React.createElement(MultiColumnFormFields, { fullWidth: true, fields: others }),
                    React.createElement(PeekDialogActions, { sx: { p: theme.spacing(2) } },
                        React.createElement(PeekButton, { size: "large", type: "submit", color: "primary", variant: "contained", fullWidth: true }, intl.formatMessage(messages.downloadButtonLabel)))))));
    }));
};
export default DownloadAnalyticsForm;
